"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _default = {
  props: ['buffer', 'message'],
  data: function data() {
    return {
      requestingInput: false,
      pluginUiSections: _GlobalApi.default.singleton().messageInfoPlugins
    };
  },
  computed: {
    showLinkPreviews: function showLinkPreviews() {
      return this.$state.setting('buffers.show_link_previews');
    }
  },
  methods: {
    urlPreview: function urlPreview(url) {
      this.$state.$emit('mediaviewer.show', url);
    },
    areWeAnOp: function areWeAnOp() {
      var ourNick = this.buffer.getNetwork().nick;
      return this.buffer.isUserAnOp(ourNick);
    },
    isSelf: function isSelf() {
      var user = this.$state.getUser(this.buffer.getNetwork().id, this.message.nick);
      return user && this.buffer.getNetwork().ircClient.user.nick === user.nick;
    },
    onBan: function onBan() {
      this.buffer.banUser(this.message.user);
    },
    onKick: function onKick(reason) {
      this.buffer.kickUser(this.message.user, reason);
    },
    openQuery: function openQuery() {
      var network = this.buffer.getNetwork();
      var buffer = this.$state.addBuffer(network.id, this.message.nick);
      this.$state.setActiveBuffer(network.id, buffer.name);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageInfo"]
window._kiwi_exports.components.MessageInfo = exports.default ? exports.default : exports;
